import { useEffect, useState } from 'react'
import { Button } from '@cannect/new-components/atoms'
import { RecurrencyCardPicker } from '@cannect/new-components/organisms/Recurrency/RecurrencyCardPicker'
import { usePatchSubscription } from '@cannect/services/resources/recurrency/hooks'
import type { SubscriptionDetail } from '@cannect/services/resources/recurrency/types'
import { subscriptionsCopy } from '../copy'
import { useSubscriptionAction } from '../hooks/useSubscriptionAction'
import { DialogShell } from './DialogShell'

const copy = subscriptionsCopy.card

type Props = { detail: SubscriptionDetail; open: boolean; onOpenChange: (open: boolean) => void }

// Só cartões já usados em compra aprovada (sem CVV, sem cadastro de cartão novo).
export const ChangeCardDialog = ({ detail, open, onOpenChange }: Props) => {
  const [cardId, setCardId] = useState<number | null>(null)
  const [error, setError] = useState<string | null>(null)
  const pausedByPayment = detail.status === 'paused' && detail.pauseReason === 'payment'

  useEffect(() => {
    if (!open) {
      setCardId(null)
      setError(null)
    }
  }, [open])

  const action = useSubscriptionAction({
    detail,
    mutation: usePatchSubscription(detail.id),
    event: 'recurrency_edit',
    eventPayload: () => ({ change: 'card' }),
    successMessage: () => (pausedByPayment ? copy.resumed : undefined),
    onErrorCode: { CARD_NOT_FOUND: (err) => setError(err.message) }
  })

  const unchanged = !cardId || cardId === detail.card?.id

  return (
    <DialogShell
      open={open}
      onOpenChange={onOpenChange}
      title={copy.title}
      footer={
        <>
          <Button variant="outline_light" onClick={() => onOpenChange(false)}>
            {subscriptionsCopy.buttons.back}
          </Button>
          <Button
            disabled={unchanged}
            isLoading={action.isPending}
            onClick={async () => {
              if (cardId && (await action.run({ cardId }))) onOpenChange(false)
            }}>
            {copy.confirm}
          </Button>
        </>
      }>
      <RecurrencyCardPicker
        value={cardId}
        onChange={(next) => {
          setCardId(next)
          setError(null)
        }}
        preselectId={detail.card?.id}
        error={error}
        showAddNew={false}
        helpText={copy.help}
        disabledReason={copy.notEligible}
      />
    </DialogShell>
  )
}
